export const themes = {
    default: { },
}
// eslint-disable-next-line import/no-anonymous-default-export
export default {theme: "default", lang:'en'};